import { render } from "./LoanModal.vue?vue&type=template&id=2b61aeba"
import script from "./LoanModal.vue?vue&type=script&lang=js"
export * from "./LoanModal.vue?vue&type=script&lang=js"
script.render = render

export default script